import { render, staticRenderFns } from "./SMultipleAttachments.vue?vue&type=template&id=cf8836da&scoped=true&"
import script from "./SMultipleAttachments.vue?vue&type=script&lang=ts&"
export * from "./SMultipleAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8836da",
  null
  
)

export default component.exports